import { render, staticRenderFns } from "./tablePositionsRow.vue?vue&type=template&id=50793a1a&"
import script from "./tablePositionsRow.vue?vue&type=script&lang=js&"
export * from "./tablePositionsRow.vue?vue&type=script&lang=js&"
import style0 from "./tablePositionsRow.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports